import { useState, useEffect } from 'react';
import api from '../../../utils/api';

/**
 * Fetches /institutes?limit=50 once on mount.
 * Returns { institutes, totalCount, uniqueCities, uniqueCourses, topInstitutes, loading, error }.
 */
function useInstitutes() {
  const [institutes, setInstitutes] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [uniqueCities, setUniqueCities] = useState(0);
  const [uniqueCourses, setUniqueCourses] = useState(0);
  const [topInstitutes, setTopInstitutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    api
      .get('/institutes', { params: { limit: 50 } })
      .then((res) => {
        if (cancelled) return;
        const data = res.data?.data || {};
        const list = data.institutes || [];
        const total = data.total ?? list.length;

        const cities = new Set(list.map((i) => i.city).filter(Boolean)).size;

        const allCourses = new Set();
        list.forEach((inst) => {
          if (Array.isArray(inst.courses_offered)) {
            inst.courses_offered.forEach((c) => {
              if (c) allCourses.add(c);
            });
          }
        });

        const sorted = [...list].sort((a, b) => {
          const aRating = a.rating || 0;
          const bRating = b.rating || 0;
          if (bRating !== aRating) return bRating - aRating;
          return (b.total_students || 0) - (a.total_students || 0);
        });

        setInstitutes(list);
        setTotalCount(total);
        setUniqueCities(cities);
        setUniqueCourses(allCourses.size);
        setTopInstitutes(sorted.slice(0, 9));
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
        setInstitutes([]);
        setTotalCount(0);
        setUniqueCities(0);
        setUniqueCourses(0);
        setTopInstitutes([]);
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { institutes, totalCount, uniqueCities, uniqueCourses, topInstitutes, loading, error };
}

export default useInstitutes;
